<template>
  <div class="mangement_target" ref="mainTable">
    <a-table :data-source="tableData" :scroll="{ y: tableScrollY }" :pagination="false" rowKey="id">
      <a-table-column title="部门名称" key="deptName" dataIndex="deptName"> </a-table-column>
      <a-table-column title="新员工学时目标" key="staffNewHours" dataIndex="staffNewHours">
        <template slot-scope="text, record, index">
          <a-input v-model="record.staffNewHours" v-if="record.edit" type="number"
            @change="inputChange(index, 'staffNewHours')" />
          <span v-else>{{ record.staffNewHours }}</span>
        </template>
      </a-table-column>
      <a-table-column title="老员工学时目标" key="staffOldHours" dataIndex="staffOldHours">
        <template slot-scope="text, record,index">
          <a-input v-model="record.staffOldHours" v-if="record.edit" type="number"
            @change="inputChange(index, 'staffOldHours')" />
          <span v-else>{{ record.staffOldHours }}</span>
        </template>
      </a-table-column>
      <a-table-column title="操作">
        <template slot-scope="text, record, index">
          <a-button type="link" @click="changeInfo(index)" v-if="!record.edit"> 编辑 </a-button>
          <a-button type="link" @click="commitInfo(index)" v-if="record.edit"> 确定 </a-button>
        </template>
      </a-table-column>
    </a-table>
    <a-table bordered :data-source="addData" :scroll="{ y: 66 }" :pagination="false" rowKey="oid" :showHeader="false"
      class="addTable">
      <a-table-column title="部门名称" key="deptId" dataIndex="deptId">
        <template slot-scope="text, record">
          <a-tree-select style="width: 210px;" v-model="record.deptId" allowClear :treeData="deptLists" tree-checkable
            :show-checked-strategy="SHOW_PARENT" placeholder="请选择" :replaceFields="options"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" maxTagCount="3" v-if="userRole=='youwei_admin'">
          </a-tree-select>
          <a-tree-select style="width: 210px" v-model="record.deptId" allowClear :treeData="deptLists" placeholder="请选择"
            :replaceFields="options" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" v-else>
          </a-tree-select>
        </template>
      </a-table-column>
      <a-table-column title="新员工学时目标" key="coverUrl" dataIndex="coverUrl">
        <template slot-scope="text, record">
          <a-input type="number" v-model="record.staffNewHours" placeholder="新员工学时目标" style="max-width: 210px"
            @change="inputChange(index, 'staffNewHours')" />
        </template>
      </a-table-column>
      <a-table-column title="老员工学时目标" key="cssClass" dataIndex="cssClass">
        <template slot-scope="text, record">
          <a-input type="number" v-model="record.staffOldHours" placeholder="老员工学时目标" style="max-width: 210px"
            @change="inputChange(index, 'staffOldHours')" />
        </template>
      </a-table-column>
      <a-table-column title="操作">
        <template slot-scope="text, record, index">
          <a-button type="link" @click="addInfo(index)"> 新增 </a-button>
        </template>
      </a-table-column>
    </a-table>
  </div>
</template>

<script>
import { getHourList, editHourInfo, checkedHourInfo, addHourInfo } from '../../../../api/course'
import { tree_all } from '../../../../api/purchase'
export default {
  data() {
    return {
      tableData: [],
      tableScrollY: 300,
      selectIndex: '',
      addData: [
        {
          oid: 1,
          deptId: undefined,
          staffNewHours: '',
          staffOldHours: '',
        },
      ],
      userInfo: {},
      positionX: 0,
      positionY: 0,
      selectColorCss: '',
      selectColorIndex: '',
      deptLists: [],
      options: {
        children: 'children',
        title: 'title',
        key: 'deptId',
        value: 'value',
      },
      userRole: '',
    }
  },
  mounted() {
    this.getDeptLists()
    this.userInfo = this.$store.getters.userInfo
    for (let i = 0; i < this.userInfo.roles.length; i++) {
      if (this.userInfo.roles[i].roleKey == "youwei_admin") {
        this.userRole = 'youwei_admin'
      }
    }
    this.$nextTick((res) => {
      this.tableScrollY = this.$refs.mainTable.offsetHeight - 130
    })
  },
  methods: {
    init() {
      this.get_lis()
      this.$nextTick((res) => {
        this.tableScrollY = this.$refs.mainTable.offsetHeight - 130
      })
    },
    inputChange(index, type) {
      if (index >= 0) {
        if (/^[0-9]+(\.[0-9]{1})?$/.test(this.tableData[index][type])) {
          return
        }
        this.tableData[index][type] = ''
      } else {
        if (/^[0-9]+(\.[0-9]{1})?$/.test(this.addData[0][type])) {
          return
        }
        this.addData[0][type] = ''
      }
    },
    addInfo() {
      if (this.userRole == 'youwei_admin') {
        let lists = []
        for (let i = 0; i < this.addData[0].deptId.length; i++) {
          let item = JSON.parse(JSON.stringify(this.addData[0]))
          item.deptId = this.addData[0].deptId[i]
          lists.push(item)
        }
        let request_lis = []
        for (let i = 0; i < lists.length; i++) {
          request_lis.push(new Promise((reslove, reject) => {
            checkedHourInfo({ deptId: lists[i].deptId }).then((res1) => {
              if (res1.code && res1.data > 0) {
                res1.type = 'res1'
                reslove(res1)
              }
              addHourInfo(lists[i]).then((res2) => {
                res2.type = 'res2'
                reslove(res2)
              })
            })
          }))
        }
        Promise.all(request_lis).then(res => {
          console.log(JSON.parse(JSON.stringify(res)));
          let reject_num = 0
          for (let i = 0; i < res.length; i++) {
            if ((res[i].type == 'res1' && res[i].code && res[i].data > 0) || (res[i].type == 'res2' && res[i].code != 200)) {
              reject_num += 1
            }
          }
          if (reject_num) {
            this.$message.error(reject_num + '个部门设置失败，请确认部门是否已存在')
          } else {
            this.$message.success('设置成功')
          }
          this.addData[0].deptId = undefined
          this.addData[0].staffNewHours = ''
          this.addData[0].staffOldHours = ''
          this.get_lis()
        })
      } else {
        checkedHourInfo({ deptId: this.addData[0].deptId }).then((res) => {
          if (res.code && res.data > 0) {
            this.get_lis()
            return this.$message.error(res.msg)
          }
          addHourInfo(this.addData[0]).then((resolve) => {
            if (resolve.code != 200) {
              return this.$message.error(resolve.msg)
            }
            this.$message.success(resolve.msg)
            this.addData[0].deptId = undefined
            this.addData[0].staffNewHours = ''
            this.addData[0].staffOldHours = ''
            this.get_lis()
          })
        })
      }
    },
    getDeptLists() {
      let _this = this
      tree_all().then((res) => {
        let deptLists = []
        if (this.userRole == "youwei_admin") {
          let data = res.data[0]
          function formatDept(lists) {
            for (let i = 0; i < lists.length; i++) {
              if (!_this.userInfo.userPermissions.includes(lists[i].deptId) && !_this.userInfo.userPermissions.includes(String(lists[i].deptId))) {
                lists.splice(i, 1)
                i--
              } else if (lists[i].children && lists[i].children.length) {
                formatDept(lists[i].children)
              }
            }
          }
          formatDept(data)
          this.deptLists = data
        } else {
          res.data[0].forEach((item) => {
            if (item.deptId == this.userInfo.companyId) {
              deptLists = item.children
              this.deptLists = deptLists
            }
          })
        }
      })
    },
    commitInfo(index) {
      editHourInfo(this.tableData[index]).then((res) => {
        if (res.code != 200) {
          return this.$message.error(res.msg)
        }
        this.$message.success('修改成功')
        this.get_lis()
      })
    },
    changeInfo(index) {
      this.$set(this.tableData[index], 'edit', true)
    },
    get_lis() {
      // axios.defaults.headers['token'] = localStorage.getItem('Access-Token').replace(/"/g, '')
      // axios({
      //   url: '/he_api/training/category/list',
      //   method: 'get',
      // }).then((res) => {
      //   console.log(res)
      //   if (res.data.code != 200) {
      //     return this.$message.error(res.msg)
      //   }
      //   this.tableData = res.data.data.list
      // })
      // return
      getHourList().then((res) => {
        if (res.code != 200) {
          return this.$message.error(res.msg)
        }
        this.tableData = res.data.list
      })
    },
  },
}
</script>

<style scoped lang="less">
.mangement_target {
  width: 100%;
  height: 100%;
  position: relative;
  .addTable {
    /deep/ .ant-table-body {
      overflow: hidden !important;
    }
  }
}
</style>